<template>
  <div class="operations">
    <Breadcrumbs :items="breadcrumbs"/>
    <rp-table
      name="operations"
      :results="getOperations"
      :headings="['patient', 'hospital', 'surgeon', {heading: 'Surgery Date', key: 'performedAt'}]"
      @rowClick="onRowClick" />
  </div>
</template>

<script>
  import Table from 'raypro_ui/src/components/ui/Table'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import page from '@/mixins/page'

  // API
  import {getUserOperations} from 'raypro_ui/src/api/operations'

  export default {
    components: {
      'rp-table': Table,
      Breadcrumbs
    },

    data() {
      return {
        operations: [],
        page: {
          totalPages: 1,
          totalentries: 0,
          pageSize: 10,
          pageNumber: 1
        },
        breadcrumbs: [
          {label: 'All Surgeries'}
        ],
        title: 'All Surgeries'
      }
    },

    mixins: [page],

    methods: {
      onRowClick(row) {
        this.$router.push(`/operations/${row.id}`)
      },
      getFullName(data, type) {
        const profile = data.profile
        let name = ''

        if(profile) {
          if(!profile.first_name && !profile.last_name) {
            return 'NOT PROVIDED'
          }
          if(profile.first_name) {
            name += `${profile.first_name}`
          }
          if(profile.last_name) {
            name += ` ${profile.last_name}`
          }
          return name
        }
        return `${type} DELETED`
      },

      getOperations(page) {
        const userId = this.$store.getters.authUser.id

        return getUserOperations(userId, page).then(({data, page}) => {
          this.page = page

          const mapped = data.map((operation) => {
            const patient = operation.patient
            const surgeon = operation.surgeon

            return {
              id: operation.id,
              patientRef: operation.patient_ref,
              patient: this.getFullName(patient, 'PATIENT'),
              hospital: operation.hospital.name,
              surgeon: this.getFullName(surgeon, 'SURGEON'),
              performedAt: new Date(operation.performed_at).toLocaleDateString()
            }
          })

          return {
            data: mapped,
            page
          }
        })
      }
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .operations
    .table
      border-radius: 5px
      box-shadow: $color-shadow

      tr
        cursor: pointer

    .table-header, .table-row
      border-bottom: 1px solid $color-grey-light
</style>



// WEBPACK FOOTER //
// src/components/pages/Operations/Operations.vue